import {post} from '../utils/ajaxHelper';
import {log as logToServer} from '../api/logger';
import {getGeneratedLocale} from '../utils/localeUtils';

function handleGraphQlError(err, operationName, options) {
    const errors = (err && err.response && err.response.body && err.response.body.errors) || [];
    let message = 'An error occurred while processing your graphql request.';
    errors.forEach((currentError) => {
        logToServer({
            graphQlService: operationName,
            graphqlerror: true,
            message: currentError.message
        });
        message = currentError.message;
    });

    if (!errors.length) {
        logToServer({
            nodeService: `${operationName} exception`,
            graphqlerror: true,
            error: err, // hits up any serialization.
            options: JSON.stringify(options)
        });
    }

    // transform all the errors into something basic.
    const errorCode = (err.response && err.response.statusCode) || 500;
    return {
        errorCode,
        originalErrorCode: errorCode, // backwards compatability
        message,
        errors
    };
}
/* eslint-disable complexity */
function mutateGraphQlResponse(response, operationName) {
    if (response.errorCode) {
        return response;
    }

    const graphqlRequestMarker =
        (response.headers && response.headers['x-homeaway-requestmarker']) || '';
    const responseBody = response.body || {data: {}};

    // We will fallback to statusCode.  I have seen a known bug where originalErrorCode is not
    // provided.
    const errorBlock =
        (responseBody.errors &&
            responseBody.errors.find((dataError) => {
                // We only care about an error if it has as statusCode in it.
                // this returns the FIRST error code
                return !!(dataError.extensions && dataError.extensions.statusCode);
            })) ||
        [];

    const pricingError = errorBlock.extensions || {};
    const graphQlErrorCode = pricingError.originalErrorCode || pricingError.statusCode || '';

    if (responseBody.errors && responseBody.errors.length) {
        responseBody.errors.forEach((currentError) => {
            logToServer({
                graphQlService: operationName,
                graphqlerror: true,
                message: currentError.message,
                graphqlRequestMarker
            });
        });
    }

    return {
        ...responseBody.data,
        originalErrorCode: graphQlErrorCode, // moved to top level for convenience
        errors: responseBody.errors, // keeping this for future proofing
        endTime: Date.now(),
        graphqlRequestMarker
    };
}
/* eslint-enable complexity */
/**
 * Handles POST to GraphQl Endpoint
 *
 * @param {*} query
 * @param {*} variables
 */
/* eslint-disable complexity */
async function graphqlQuery(operation, query, variables, locale, waitForAccessToken) {
    let options = {
        query,
        variables,
        operation
    };

    const headers = {};

    if (locale) {
        headers['X-HomeAway-DisplayLocale'] = getGeneratedLocale(locale);
    }

    const url = '/pdp/graphql';
    const result = await post(url, options, headers, waitForAccessToken).catch((err) => {
        return handleGraphQlError(err, operation, variables);
    });

    // handleGraphQlError will add an errorCode, and already setup what we
    // want to return.
    if (!result.errorCode) {
        return mutateGraphQlResponse(result, operation);
    }

    return result;
}
/* eslint-enable complexity */

export default graphqlQuery;
export {graphqlQuery, handleGraphQlError, mutateGraphQlResponse};
